import React from 'react';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ManageSliders from '@app/components/manage-sliders/ManageSliders';

const ManageSlidersPage: React.FC = () => {
  return (
    <>
      <PageTitle>Home Screen Sliders</PageTitle>
      <ManageSliders />
    </>
  );
};

export default ManageSlidersPage;
